/**
 * Instagram Icon
 * 
 * Uses Font Awesome under the hood for maintained, up-to-date brand icons.
 */

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import type { IconProps } from '../../types';

export function InstagramIcon({ 
  className, 
  size = 24, 
  color,
  'aria-label': ariaLabel = 'Instagram',
}: IconProps) {
  return (
    <FontAwesomeIcon 
      icon={faInstagram}
      className={className}
      style={{ 
        width: typeof size === 'number' ? size : undefined,
        height: typeof size === 'number' ? size : undefined,
      }}
      color={color}
      aria-label={ariaLabel}
      role="img"
    />
  );
}
